import React from 'react';

const WidgetRss = ({width = 20, height = 20, couleur = "#A8B0B3"}) => (
    <svg width={width} height={height} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="icons MASTER">
            <path id="Ellipse 43"
                  d="M5.74205 5.51186C9.68655 5.51186 13.5924 6.28878 17.2367 7.79827C20.8809 9.30777 24.1921 11.5203 26.9813 14.3094C29.7705 17.0986 31.983 20.4099 33.4925 24.0541C35.002 27.6983 35.7789 31.6042 35.7789 35.5487"
                  stroke={couleur} strokeWidth="4"/>
            <path id="Ellipse 44"
                  d="M5.74173 14.8979C8.45357 14.8979 11.1389 15.4321 13.6443 16.4698C16.1497 17.5076 18.4262 19.0287 20.3437 20.9463C22.2613 22.8638 23.7824 25.1403 24.8202 27.6457C25.8579 30.1511 26.3921 32.8364 26.3921 35.5483"
                  stroke={couleur} strokeWidth="4"/>
            <path id="Ellipse 45"
                  d="M5.74238 24.2859C7.22157 24.2859 8.68627 24.5773 10.0529 25.1433C11.4194 25.7094 12.6612 26.5391 13.7071 27.585C14.753 28.631 15.5827 29.8727 16.1488 31.2393C16.7149 32.6059 17.0062 34.0706 17.0062 35.5498"
                  stroke={couleur} strokeWidth="4"/>
            <circle id="Ellipse 46" cx="7.15527" cy="34.1358" r="2.93826" transform="rotate(45 7.15527 34.1358)"
                    fill={couleur}/>
        </g>
    </svg>

);

export default WidgetRss;
